module.exports = __webpack_public_path__ + "6e386af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/static/avatarDefault.png
// module id = 886
// module chunks = 2 3 4 7 8